import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Form, Table, Popconfirm, Typography, message, Modal } from 'antd';
import moment from 'moment';
import { ProviderForm } from '../components/billSearchForm';
import BillAuto from '../components/billAuto';
import { reconciliation, updateReconciliation } from '../api';
import { BILL_STATUS } from '../billConst';
import { amountToString } from '../../../util/tool';
import Signature from '../components/signature';
import '../index.less';

const progressStatusTitle = { create_time: '生成账单', confirm_time: '确认账单', pay_time: '确认支付', finish_time: '完成', cancel_time: '取消', };

export default function Bill() {
  const history = useHistory();
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [progressTableData, setProgressTableData] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 10 });
  const childrenRef = useRef();
  const searchFn = () => { setPageConfig({ ...pageConfig, page: 1 }); };
  const [reconciliationNo, setReconciliationNo] = useState('');
  const params = new URLSearchParams(window.location.search);
  const order_no = params.get('order_no');
  useEffect(() => {
    async function getReconciliation() {
      const { dateRange = [], ...formValues } = childrenRef.current.form.getFieldsValue() || {};
      const [start_time, end_time] = dateRange.map(item => moment(item).format('YYYY-MM-DD'));
      const { data: { code, msg, data } } = await reconciliation({ ...formValues, start_time, end_time, ...pageConfig });
      if (+code === 0) {
        const { list = [], total } = data;
        setTableData(list);
        setTotalPage(total);
      } else {
        message.error(msg);
      }
    }
    getReconciliation();
  }, [pageConfig]);

  const tablePageChange = (page, pageSize) => {
    setPageConfig({ ...pageConfig, page });
  };

  const print = record => {
    const { reconciliation_no } = record;
    history.push(`/basic/user/bill/print/${reconciliation_no}`);
  };

  const viewProgress = record => {
    const { create_time, confirm_time, pay_time, finish_time, cancel_time } = record;
    const progressStatus = { create_time, confirm_time, pay_time, finish_time, cancel_time };
    const progressData = Reflect.ownKeys(progressStatus).filter(item => progressStatus[item]).map((item, index) => ({ title: progressStatusTitle[item], current_time: record[item], id: index }));

    setVisibleModal(true);
    setProgressTableData(progressData);
  };

  const modalHandleCancel = () => {
    setVisibleModal(false);
  };

  const pay = async (record, status) => {
    const { reconciliation_no } = record;
    const { data: { code, msg } } = await updateReconciliation({ reconciliation_no, status });
    if (+code === 0) {
      setPageConfig({ page: 1, page_size: 10 });
    } else {
      message.error(msg);
    }
  };

  const goToDetail = record => {
    const { reconciliation_no } = record;
    history.push(`/basic/user/bill/detail/${reconciliation_no}`);
  };

  const openSignModal = (record) => {
    setReconciliationNo(record.reconciliation_no);
  };

  const update = () => {
    setReconciliationNo('');
    setPageConfig({ page: 1, page_size: 10 });
  };

  const onCancel = () => {
    setReconciliationNo('');
  };

  const columns = [
    {
      title: '对账单编号',
      dataIndex: 'reconciliation_no',
    },
    {
      title: '对账单状态',
      dataIndex: 'status',
      render: text => (BILL_STATUS[+text] || '-')
    },
    {
      title: '供应商',
      dataIndex: 'supplier_name',
    },
    {
      title: '供应商编码',
      dataIndex: 'supplier_id',
    },
    {
      title: '结算金额含税-合计（元）',
      dataIndex: 'total_amount',
      render: text => amountToString(text),
    },
    {
      title: '操作',
      render: (_, record) => {
        const { status = 0, is_signature } = record;
        return (<>
          {
            +status === 10 ? <>
              {+is_signature === 0 ? <Popconfirm title={`是否账单确认?`} cancelText='驳回' onConfirm={() => pay(record, '20')} onCancel={() => pay(record, 50)}>
                <Typography.Link className='bill-operate-btn promote-btn'>账单确认</Typography.Link>
              </Popconfirm> : <Typography.Link className='bill-operate-btn promote-btn' onClick={() => openSignModal(record)}>账单确认</Typography.Link>}
            </> : null
          }
          {
            +status === 20 ? (<Popconfirm title={`是否确认支付?`} onConfirm={() => pay(record, '30')}>
              <Typography.Link className='bill-operate-btn promote-btn' >确认支付</Typography.Link>
            </Popconfirm>) : null
          }
          <Typography.Link className='bill-operate-btn' onClick={() => goToDetail(record)}>详情</Typography.Link>
          <Typography.Link className='bill-operate-btn' onClick={() => print(record)}>打印</Typography.Link>
          <Typography.Link className='bill-operate-btn' onClick={() => viewProgress(record)}>结算进度</Typography.Link>
        </>);
      },
    },
  ];
  const progressColumns = [
    {
      title: '操作',
      dataIndex: 'title',
      width: '20%',
    },
    {
      title: '时间',
      dataIndex: 'current_time',
      width: '10%',
    },
  ];
  return (
    <div className='bill-container'>
      <div className='title'>我的对账单</div>
      <ProviderForm ref={childrenRef} searchFn={searchFn} defaultValue={{ order_no }} />
      <BillAuto />
      <Form form={form} component={false}>
        <Table
          dataSource={tableData}
          columns={columns}
          rowClassName="editable-row"
          rowKey='reconciliation_no'
          pagination={{
            pageSize: pageConfig.page_size,
            total: totalPage,
            current: pageConfig.page,
            onChange: tablePageChange
          }}
        />
      </Form>
      <Modal
        open={visibleModal}
        onCancel={modalHandleCancel}
        footer={null}
      >
        <Table
          bordered
          dataSource={progressTableData}
          columns={progressColumns}
          rowKey='id'
          pagination={false}
        >
        </Table>
      </Modal>
      {reconciliationNo ? <Signature reconciliation_no={reconciliationNo} update={update} onCancel={onCancel} /> : null}
    </div>
  );
};



